'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('style-inject');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styleInject__default = /*#__PURE__*/_interopDefaultLegacy(styleInject);

var css_248z = ".Header-module_header__RDN94{color:#000;font-family:inherit;font-weight:700;margin:0}.Header-module_hugeHeader__SbpNF{font-size:6rem}.Header-module_bigHeader__8RjOR{font-size:2.125rem}.Header-module_semiBigHeader__bDKbI{font-size:1.5rem}.Header-module_mediumHeader__DI4D6{font-size:1.125rem}.Header-module_smallHeader__f8K0m{font-size:.875rem}";
var styles = {"header":"Header-module_header__RDN94","hugeHeader":"Header-module_hugeHeader__SbpNF Header-module_header__RDN94","bigHeader":"Header-module_bigHeader__8RjOR Header-module_header__RDN94","semiBigHeader":"Header-module_semiBigHeader__bDKbI Header-module_header__RDN94","mediumHeader":"Header-module_mediumHeader__DI4D6 Header-module_header__RDN94","smallHeader":"Header-module_smallHeader__f8K0m Header-module_header__RDN94"};
styleInject__default["default"](css_248z);

exports["default"] = styles;
